<div id="attribute">
    <div class="title-head" fxLayout="row" fxLayoutAlign="space-between center" color="primary">
        <span>
            ADD DEALS PAYMENT
        </span>
        <button [attr.guide]="'add-deals-payment-btn-1' + '__' + sanitizedUrl" mat-dialog-close mat-icon-button>
            <mat-icon>
                close
            </mat-icon>
        </button>
    </div>
    <div class="padding-10">
        <span>
            Please fill in the information below. The field labels marked with * are required input fields.
        </span>
        s
    </div>

    <form [formGroup]="firstFormGroup">
        <div class="padding-10">

            <form autocomplete="off" style="padding:10px;" [formGroup]="firstFormGroup">

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="12px">

                    <mat-form-field fxFlex="50" appearance="outline">
                        <mat-label>Date</mat-label>
                        <input [attr.guide]="'add-deals-payment-inp-date' + '__' + sanitizedUrl" disabled
                            [autocomplete]="'off'" formControlName="date" matInput [matDatepicker]="date" />
                        <mat-datepicker-toggle matSuffix [for]="date">
                        </mat-datepicker-toggle>
                        <mat-datepicker #date disabled="false"> </mat-datepicker>
                    </mat-form-field>

                    <mat-form-field fxFlex="50" appearance="outline">
                        <mat-label>Reference No</mat-label>
                        <input [attr.guide]="'add-deals-payment-inp-referenceno' + '__' + sanitizedUrl"
                            [autocomplete]="'off'" trim="blur" matInput formControlName="referenceNo" />

                    </mat-form-field>

                </div>
                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                    <mat-form-field fxFlex appearance="outline">
                        <mat-label>Amount</mat-label>
                        <input numbersOnly [attr.guide]="'add-deals-payment-inp-amount' + '__' + sanitizedUrl" matInput
                            formControlName="amount" required />
                        <mat-error *ngIf="firstFormGroup.controls.amount.errors?.required">
                            Please fill out this field.</mat-error>
                        <mat-error *ngIf="firstFormGroup.controls.amount.errors?.min">
                            Amount must be greater than 0.</mat-error>
                        <mat-error *ngIf="firstFormGroup.controls.amount.errors?.max">
                            Amount cannot exceed the remaining balance of {{remainingBalance}}.</mat-error>
                    </mat-form-field>
                </div>


                <br>


                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                    <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                        <mat-label>Payment Notes</mat-label>
                        <textarea [attr.guide]="'add-deals-payment-sel-note' + '__' + sanitizedUrl" trim="blur" matInput
                            matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                            formControlName="note"></textarea>
                    </mat-form-field>

                </div>

            </form>
            <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
                <button [attr.guide]="'add-deals-payment-btn-2' + '__' + sanitizedUrl" mat-raised-button
                    (click)="close()">Cancel</button>
                <button [attr.guide]="'add-deals-payment-btn-3' + '__' + sanitizedUrl" [disabled]="text !='Save'"
                    (click)="submit()" mat-raised-button>
                    {{text}}
                    <mat-icon *ngIf="text !='Save' ">
                        <mat-spinner color="primary" diameter="20">
                        </mat-spinner>
                    </mat-icon>
                </button>
            </div>
        </div>